import React, { useState } from "react";
function SharedGPAPlanner() {
  const [currentGPA, setCurrentGPA] = useState(0);
  const [targetGPA, setTargetGPA] = useState(0);
  const [currentCredits, setCurrentCredits] = useState(0);
  const [additionalCredits, setAdditionalCredits] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const calculateRequiredGPA = () => {
    const requiredGPA =
      (targetGPA * (currentCredits + additionalCredits) -
        currentGPA * currentCredits) /
      additionalCredits;
    if (requiredGPA <= 4.0) {
      return (
        <div>
          لتحقيق المعدل التراكمي المستهدف وهو <strong>{targetGPA}</strong>، يجب
          أن يكون المعدل التراكمي للساعات <strong>{additionalCredits}</strong>{" "}
          التالية <strong>{requiredGPA.toFixed(3)}</strong> أو أعلى.
        </div>
      );
    } else {
      return (
        <div>
          ليس من الممكن تحقيق المعدل التراكمي المستهدف باستخدام الاعتمادات
          المعطاة والمعدل التراكمي الحالي.
        </div>
      );
    }
  };
  const handleCalculateClick = () => {
    setShowResult(true);
    setError(null);
  };
  return (
    <div className="rtl" id="gpaPlannerContainer">
      <div className="row">
        <div className="col-sm-12 col-md-7 calculatorStyle">
          <div className="p-3 mb-2 bg-success text-white">
            <h2 style={{ fontSize: "16px" }} id="calculatorTitle">
              حاسبة تخطيط المعدل التراكمي
            </h2>
          </div>
          <hr />
          <div
            className="form-group d-flex align-items-center mb-2"
            id="currentGPAGroup"
          >
            <b>
              {" "}
              <label htmlFor="currentGPA">المعدل التراكمي الحالي:</label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={currentGPA}
              onChange={(e) => setCurrentGPA(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="currentGPA"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="targetGPAGroup"
          >
            <b>
              {" "}
              <label htmlFor="targetGPA">
                المعدل التراكمي الذي تريد الوصول اليه:
              </label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={targetGPA}
              onChange={(e) => setTargetGPA(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="targetGPA"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="currentCreditsGroup"
          >
            <b>
              {" "}
              <label htmlFor="currentCredits">عدد الساعات المجتازة:</label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={currentCredits}
              onChange={(e) => setCurrentCredits(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="currentCredits"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="additionalCreditsGroup"
          >
            <b>
              {" "}
              <label htmlFor="additionalCredits">
                عدد الساعات التي تريد تسجيلها:
              </label>
            </b>
            <input
              type="number"
              value={additionalCredits}
              onChange={(e) => setAdditionalCredits(parseFloat(e.target.value))}
              className="form-control"
              style={{ width: "30%", marginRight: "10px" }}
              step="0.01"
              id="additionalCredits"
            />
          </div>
          <button
            className="btn btn-success mt-3"
            onClick={handleCalculateClick}
            id="calculateButton"
          >
              احسب          </button>
          <br />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-12 col-md-7">
          {error && (
            <div className="alert alert-warning">
              <b>
                <u> حدث خطأ :</u>
              </b>{" "}
              يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
            </div>
          )}
          {showResult &&   (
            <div
              style={{ fontSize: "16px" }}
              className="bg-light bg-gradient text-dark"
              id="resultContainer"
            >
              <div className="p-3 bg-success bg-gradient text-white">
                <strong id="resultsTitle">النتائج</strong>
              </div>
              {calculateRequiredGPA()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default SharedGPAPlanner;
